// App Store listing for the GetCode iOS app. The slug is cosmetic — Apple
// resolves the listing by the numeric id — but it's kept in sync with the
// current app name.
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/getcode-2nd-phone-number/id6760430086'

// Google Play listing (placeholder until the Android app ships).
export const PLAY_STORE_URL = 'https://play.google.com/store'

// Primary "download the app" target used by CTAs across the site.
export const PRIMARY_APP_DOWNLOAD_URL = APP_STORE_URL
